import { gql } from "apollo-boost";

export const GET_BRANDS = gql`
  query Brands(
    $where: BrandWhereInput
    $orderBy: OrderByInput
    $skip: Int
    $limit: Int
  ) {
    brands(where: $where, orderBy: $orderBy, skip: $skip, limit: $limit) {
      total
      data {
        id
        name
        detail
        createdAt
        category {
          id
          name
        }
      }
    }
  }
`;
